import { AfterViewInit, Component } from '@angular/core';
import { TableModule } from 'primeng/table';
import { AuthService } from '../../../core/services/auth.service';
import { I18nService } from '../../../core/services/i18n.service';
import { SpsSupportInfoComponent } from '../../../custom/components/sps-support-info/sps-support-info.component';
import { LayoutService } from '../../../layout/services/layout.service';
import { SidebarMenuService } from '../../../layout/services/sidebar-menu.service';
import { BaseComponent } from '../base/base.component';
import { DbAddBusinessPartnerComponent } from './custom-views/db-add-business-partner/db-add-business-partner.component';
import { DbBusinessPartnerComponent } from './custom-views/db-business-partner/db-business-partner.component';
import { DbLatestTransactionsComponent } from './custom-views/db-latest-transactions/db-latest-transactions.component';
import { DbPaymentMethodsComponent } from './custom-views/db-payment-methods/db-payment-methods.component';

@Component({
  selector: 'app-dashboard',
  imports: [
    TableModule,
    DbLatestTransactionsComponent,
    DbPaymentMethodsComponent,
    SpsSupportInfoComponent,
    DbAddBusinessPartnerComponent,
    DbBusinessPartnerComponent,
  ],
  templateUrl: './dashboard.component.html',
})
export class DashboardComponent extends BaseComponent implements AfterViewInit {

  constructor(public authService: AuthService,
              public i18n: I18nService,
              public layoutService: LayoutService,
              private sidebarMenuService: SidebarMenuService) {
    super();
  }

  ngAfterViewInit(): void {
    /**
     * Initialize Breadcrumb-Items
     */
    setTimeout(() => {
      this.i18n.breadcrumbMenuItems.set([
        {
          icon: 'pi pi-home',
          i18nLabelKey: 'MENUDASHBOARD',
          label: this.i18n?.i18nLng()['MENUDASHBOARD'],
          routerLinkActive: true,
        },
      ]);
      try {
        this.layoutService.sidebarMenu.activateMenuItem(this.sidebarMenuService.findMenuItemById(this.sidebarMenuService.menuItems, 'm-dashboard'));
      } catch (e) {
      }
    }, 50);
  }

  changeLanguage() {
    if (this.i18n.activeLanguageKey() === 'de') {
      this.i18n.initPrimengTranslation('en');
      this.i18n.initLanguageData('en');
    } else {
      this.i18n.initPrimengTranslation('de');
      this.i18n.initLanguageData('de');
    }
  }

  /**
   * REMOVE
   * only for testing the blocking of the document
   * @private
   */
  blockDocument() {
    this.layoutService.blockDocument.set(true);
    setTimeout(() => {
      this.layoutService.blockDocument.set(false);
    }, 2500);
  }

}
